/**
 * Construction du numéro de sinistre pour les appels de lien document :
 * On prend les dizaines de l'année du sinistre : 2024 donne 24
 * On prend le numéro de dossier et on ajoute des 0 devant pour que le total fasse 8 caractères :
 * 5864 donne 00005864
 * Finalement, on prend la première partie qu'on met devant la deuxième :
 * 2400005864
 * @param numeroDossier
 * @param annee
 * @returns {`${*}${string}`}
 */
export const buildNumeroSinistre = (numeroDossier, annee) => {

    return `${ annee?.slice(2, 4) }${ numeroDossier.padStart(8, '0') }`
}

export const isIndemnisationsAuthorized = (produit) => {

    const PRODUITS_INDEMNISES = window?.confPub?.PRODUITS_INDEMNISES

    return PRODUITS_INDEMNISES.includes(produit)
}